import {
  Handshake,
  Home,
  ProductionQuantityLimits,
  Web,
  Apartment,
  CalendarToday,
  Group,
  Person,
  RssFeed,
  Subscriptions,
  Message,
  AccountBalance,
  Business,
  RateReview,
  People,
  MoreVert,
} from "@mui/icons-material";

import { Menu } from "../model/menu";

export const menus: Menu[] = [
  {
    name: "Dashboard",
    path: "/",
    icon: Home,
  },
  {
    name: "Projects",
    path: "/projects",
    icon: Web, // You might change this to something better if you want (see below)
  },
  {
    name: "Units",
    path: "/units",
    icon: Apartment, // Building icon, fits "units" (apartments, offices)
  },
  {
    name: "Unit Types",
    path: "/unit-types",
    icon: Apartment, // Building icon, fits "units" (apartments, offices)
  },
  {
    name: "Scheduled Visit",
    path: "/scheduled-visits",
    icon: CalendarToday, // Calendar icon, fits "scheduled visit"
  },
  {
    name: "User",
    path: "/users",
    icon: Person, // Single user
  },
  {
    name: "Blog",
    path: "/blogs",
    icon: RssFeed, // RSS feed icon fits "blog"
  },
  {
    name: "Bank Accounts",
    path: "/bank-accounts",
    icon: AccountBalance, // Bank account icon
  },
  {
    name: "More",
    icon: MoreVert,
    child: [
      {
        name: "Testimonial",
        path: "/testimonials",
        icon: RateReview, // Review/rating icon for testimonials
      },
      {
        name: "Partners",
        path: "/partners",
        icon: Handshake, // Handshake icon for partners
      },
      {
        name: "Team",
        path: "/teams",
        icon: Group, // Group/team icon
      },
      {
        name: "Subscribers",
        path: "/subscribers",
        icon: Subscriptions, // Subscription icon
      },
      {
        name: "Newsletters",
        path: "/newsletters",
        icon: RssFeed, // RSS feed icon for newsletters
      },
      {
        name: "Messages",
        path: "/messages",
        icon: Message, // Message icon
      },
    ],
  },
];
